module.exports = __webpack_public_path__ + "img/banner.3e3eea46.png";